import React, { useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

export default function FilterModal({ filters, open, handleClose, handleApply }) {
  const [localFilters, setLocalFilters] = useState({});
  
  useEffect(() => {
    setLocalFilters(filters)
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters({ ...localFilters, [name]: value });
  };

  const handleApplyClick = () => {
    setLocalFilters(localFilters)
    handleApply(localFilters);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} style={{height: '50%'}}>
      <DialogTitle>Apply Filters</DialogTitle>
      <DialogContent>
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-4">
          <TextField name="contactType" value={localFilters.contactType} label="Purpose" variant="outlined" onChange={handleInputChange} fullWidth margin="normal" />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-4">
          <TextField name="requesterName" value={localFilters.requesterName} label="Requester Name" variant="outlined" onChange={handleInputChange} fullWidth margin="normal" />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-4">
          <TextField name="contactEmailId" value={localFilters.contactEmailId} label="Contact Email ID" variant="outlined" onChange={handleInputChange} fullWidth margin="normal" />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-4">
          <TextField name="contactPhoneNumber" value={localFilters.contactPhoneNumber} label="Contact Phone Number" variant="outlined" onChange={handleInputChange} fullWidth margin="normal" />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-4">
          <TextField name="assigneeFullName" value={localFilters.assigneeFullName} label="Assignee Name" variant="outlined" onChange={handleInputChange} fullWidth margin="normal" />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-4">
          <TextField name="status" value={localFilters.status} label="Status" variant="outlined" onChange={handleInputChange} fullWidth margin="normal" />
        </div>
      </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button onClick={handleApplyClick}>Apply Filter</Button>
      </DialogActions>
    </Dialog>
  );
}
